import { reportSentryError } from '@klarna-web-sdk/utils/src/sentry/reportSentryError'

import { CSPError } from '../../errors'

let isRegistered = false

const supportedKlarnaDomains = ['*.klarna.com', '*.klarnaservices.com', '*.klarnacdn.net']

function matchesKlarnaDomain(uri: string): boolean {
  try {
    const { hostname } = new URL(uri)
    return supportedKlarnaDomains.some((pattern) => {
      // Remove leading * for wildcard match
      if (pattern.startsWith('*')) {
        const domain = pattern.slice(1)
        return hostname.endsWith(domain)
      }
      return hostname === pattern
    })
  } catch {
    // If not a valid URL, do not match
    return false
  }
}

/**
 * Adds a global event listener for security policy violations.
 * This is a workaround to catch CSP errors that are not reported by the browser.
 * See https://klarna-1.sentry.io/issues/6682546212/events/97d480e66197426c9290811e95b5edcc/
 * @returns void
 */
export function registerGlobalCSPHandler() {
  if (isRegistered) return
  if (typeof window !== 'undefined' && window.addEventListener) {
    window.addEventListener('securitypolicyviolation', (event) => {
      // report only Klarna domains errors to avoid noise
      if (event.blockedURI && matchesKlarnaDomain(event.blockedURI)) {
        reportSentryError(new CSPError(event))
      }
    })
    isRegistered = true
  }
}
